import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuditCategory, AuditLog, AuditLogQuery, PagedResult } from '../models/audit-log.model';

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  private apiUrl = `${environment.apiUrl}/AuditLog`;

  constructor(private http: HttpClient) {}

  query(q: AuditLogQuery): Observable<PagedResult<AuditLog>> {
    let params = new HttpParams()
      .set('pageNumber', q.pageNumber.toString())
      .set('pageSize', q.pageSize.toString());

    if (q.category) params = params.set('category', q.category);
    if (q.entityName) params = params.set('entityName', q.entityName);
    if (q.action) params = params.set('action', q.action);
    if (q.changedBy) params = params.set('changedBy', q.changedBy);
    if (q.fromDate) params = params.set('fromDate', q.fromDate);
    if (q.toDate) params = params.set('toDate', q.toDate);
    if (q.search) params = params.set('search', q.search);

    return this.http.get<PagedResult<AuditLog>>(this.apiUrl, { params }).pipe(retry(1));
  }

  getEntityNames(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/entity-names`).pipe(retry(1));
  }

  getCategories(): Observable<AuditCategory[]> {
    return this.http.get<AuditCategory[]>(`${this.apiUrl}/categories`).pipe(retry(1));
  }
}
